import { Fornecedor } from "../../components/fornecedor/Fornecedor";

export const FornecedorPage = () => {
    return (
        <div style={{
            margin: "auto"
        }}>
            <Fornecedor />
        </div>
    );
};
